import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/5 bg-background pt-16 pb-8" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6" data-id="element-93">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-16" data-id="element-94">
          <div className="flex flex-col items-center md:items-start gap-3" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/3xYroZLPAMD9fyhKSUfZfq/ChatGPT_Image_Jul_9,_2026,_05_00_14_PM.png" alt="Stopply symbol" className="h-10 w-10 object-contain opacity-90" data-id="element-96" />
            <p className="text-sm text-textSecondary" data-id="element-97">A LetLois Company.</p>
          </div>

          <div className="flex gap-8 text-sm font-medium text-textSecondary" data-id="element-98">
            <a href="#" className="hover:text-white transition-colors" data-id="element-99">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-100">
              Terms
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-101">
              Contact
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-102">
              Social
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-textSecondary/50" data-id="element-103">
          &copy; {new Date().getFullYear()} Stopply. All rights reserved.
        </div>
      </div>
    </footer>;
}